import api from './axios';
import { AuthResponse, ApiResponse, User } from '../types';

export const authAPI = {
  register: async (data: {
    email: string;
    password: string;
    first_name: string;
    last_name: string;
    phone?: string;
  }) => {
    const res = await api.post<ApiResponse<AuthResponse>>('/api/auth/register', data);
    return res.data;
  },

  login: async (data: { email: string; password: string }) => {
    const res = await api.post<ApiResponse<AuthResponse>>('/api/auth/login', data);
    return res.data;
  },

  verifyEmail: async (token: string) => {
    const res = await api.get<ApiResponse<{}>>(`/api/auth/verify-email?token=${token}`);
    return res.data;
  },

  forgotPassword: async (email: string) => {
    const res = await api.post<ApiResponse<{}>>('/api/auth/forgot-password', { email });
    return res.data;
  },

  resetPassword: async (data: { token: string; new_password: string }) => {
    const res = await api.post<ApiResponse<{}>>('/api/auth/reset-password', data);
    return res.data;
  },

  refreshToken: async () => {
    const res = await api.post<ApiResponse<{ token: string }>>('/api/auth/refresh-token');
    return res.data;
  },

  getProfile: async () => {
    const res = await api.get<ApiResponse<User>>('/api/users/profile');
    return res.data;
  },

  updateProfile: async (data: {
    first_name?: string;
    last_name?: string;
    phone?: string;
  }) => {
    const res = await api.put<ApiResponse<User>>('/api/users/profile', data);
    return res.data;
  },

  changePassword: async (data: {
    current_password: string;
    new_password: string;
  }) => {
    const res = await api.put<ApiResponse<{}>>('/api/users/change-password', data);
    return res.data;
  },
};